<template>
  <a-spin :spinning="confirmLoading" :tip="spinTips">

    <j-form-container style="margin-bottom: 50px;">
      <a-form :form="form" slot="detail">
        <a-row class="form-box">
          <a-col :span="24" v-if="driverList.length>0">
            <div class="info-card" v-for="info in driverList">
              <a-row class="info-item">
                <a-col :span="6" class="info-label">客户姓名：</a-col>
                <a-col :span="18" class="info-value" :class="info.hasLabel?'red-text':''">{{ info.driverName }}</a-col>
              </a-row>
              <a-row class="info-item">
                <a-col :span="6" class="info-label">身份证号：</a-col>
                <a-col :span="18" class="info-value">{{ info.idNumber }}</a-col>
              </a-row>
              <a-row class="info-item">
                <a-col :span="6" class="info-label">所属城市：</a-col>
                <a-col :span="18" class="info-value">{{ info.areaName }}</a-col>
              </a-row>
              <a-row class="info-item">
                <a-col :span="6" class="info-label">手机号：</a-col>
                <a-col :span="18" class="info-value">
                    <span v-if="info.phoneList" v-for="(phone,idx) in info.phoneList" :class="phone.hasStatus?'red-text':''">
                      {{phone.phone}}{{(info.phoneList.length-1)>idx?',':''}}
                    </span>
                </a-col>
              </a-row>
              <a-row class="info-item">
                <a-col :span="6" class="info-label">车牌号：</a-col>
                <a-col :span="18" class="info-value red-text">
                     <span v-if="info.carList" v-for="(car,idx) in info.carList" :class="car.hasLabel?'red-text':''">
                      {{car.licensePlateNumber}}{{(info.carList.length-1)>idx?',':''}}
                    </span>
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col :span="24" v-else>
            <a-form-item label="客户姓名">
              <!--<a-button   type="primary" v-if="model.dx">{{model.driverName}}</a-button>-->
              <a-input  :disabled="true"  v-decorator="['driverName', validatorRules.driverName]"  ></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :span="24" v-if="model.licensePlateNumber">-->
<!--            <a-form-item label="绑定车辆">-->
<!--              &lt;!&ndash;<a-button   type="primary">{{model.driverName}}</a-button>&ndash;&gt;-->
<!--              <a-input  :disabled="true"   v-model="model.licensePlateNumber"  ></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="24">
            <a-form-item label="项目名称">
<!--             <j-dict-select-tag :disabled="formDisabled" type="list" v-decorator="['businessSegment', validatorRules.businessSegment]" :trigger-change="true" dictCode="business_segment" placeholder="请选择业务板块" />-->
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择项目名称"
                v-decorator="['businessSegment', validatorRules.businessSegment]"
                dict="business_segment">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="工单类型" >
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择工单类型"
                v-decorator="['workOrderType', validatorRules.workOrderType]"
                :dictOptions="parentList">
              </j-search-select-tag>
            </a-form-item>

          </a-col>

          <a-col :span="24">
            <a-form-item label="转交给">
              <!--<j-dict-select-tag :disabled="formDisabled" type="list"  v-decorator="['transfer', validatorRules.transfer]"  :trigger-change="true" :options="ccList" placeholder="请选择转交人" />-->
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择转交人"
                v-decorator="['transfer', validatorRules.transfer]"
                :dictOptions="ccList">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="回收方式">
              <j-dict-select-tag :disabled="formDisabled" type="list"
                                 @change="switchType"
                                 v-decorator="['backType', validatorRules.backType]" :trigger-change="true" dictCode="back_type" placeholder="请选择回收方式" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="model.backType == 1">
            <a-form-item label="倒计时">
              <a-input-number :formatter="(value) => `${value}`"
                              :precision="0"
                              :parser="(value) => value.replace('.', '')" :min="0" :max="999" :maxLength="3"  v-model="model.day"  style="width: 100px"></a-input-number>
              <span style="margin: 0 10px">天</span>
              <a-input-number  :formatter="(value) => `${value}`"
                               :precision="0"
                               :parser="(value) => value.replace('.', '')" :min="0" :max="23" :maxLength="2" v-model="model.hour"  style="width: 100px"></a-input-number>
              <span style="margin: 0 10px">小时</span>
              <a-input-number   :formatter="(value) => `${value}`"
                                :precision="0"
                                :parser="(value) => value.replace('.', '')" :min="0" :max="59" :maxLength="2" v-model="model.minutes"  style="width: 100px"></a-input-number>
              <span style="margin: 0 10px">分钟</span>
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="model.backType == 2">
            <a-form-item label="指定日期">
              <a-date-picker show-time placeholder="请选择指定日期" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" v-decorator="['backTime']"/>
            </a-form-item>
          </a-col>
          <!--<a-col :span="24">-->
            <!--<a-form-item label="传达类型"  >-->
              <!--<j-search-select-tag-->
                <!--placeholder="请选择传达类型"-->
                <!--ref="child"-->
                <!--v-decorator="['workOrderTypeChild', validatorRules.workOrderTypeChild]"-->
                <!--:dictOptions="typeChildList">-->
              <!--</j-search-select-tag>-->
            <!--</a-form-item>-->
          <!--</a-col>-->

          <!--<a-col :span="24">-->
            <!--<a-form-item label="快捷短语" >-->
              <!--<j-dict-select-tag  type="list" v-decorator="['phrases', validatorRules.phrases]" :trigger-change="true" dictCode="workorder_phrases_1" placeholder="请选择快捷短语" />-->
            <!--</a-form-item>-->
          <!--</a-col>-->
          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea  :disabled="formDisabled"   v-decorator="['remark', validatorRules.remark]" rows="4" placeholder="请输入备注" />
            </a-form-item>
            <!--<div class="phrases-box" v-if="phrases">-->
              <!--<div v-for="it in workorder_phrases" v-if="it.value.indexOf(phrases)!=-1 && it.value!=phrases" @click="choosePhrases(it.value)" v-html="formatSearchConetnt(it.value,phrases)">-->
              <!--</div>-->

            <!--</div>-->
          </a-col>
          <div ref="pasteContainer">
          <a-col :span="24" >
            <a-form-item label="图片附件">
              <j-image-upload  :disabled="disabled" :width="0" :height="0" :number="6" :isMultiple="true"  bizPath="imageFile"    v-decorator="['imageFile']" ></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item label="视频附件">
              <j-upload  :disabled="disabled" fileType="mp4"  :number="3" :isMultiple="true"  bizPath="imageVideo_videoUrl_notzip"    v-decorator="['videoUrl']" ></j-upload>
            </a-form-item>
          </a-col>
          </div>
        </a-row>
      </a-form>
    </j-form-container>

    <view-modal-info ref="driverForm"></view-modal-info>
  </a-spin>
</template>

<script>
  import { formatSearchConetnt,by_str } from '@/utils/util'
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import axios from 'axios';
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { validateDuplicateValue } from '@/utils/util'
  import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
  import {Modal} from "ant-design-vue";
import { getAccessToken } from '@/utils/token'
  export default {
    name: 'DmWorkOrderForm',
    components: {
      ViewModalInfo: () => import('../../../dm3.0/driver/DriverInfo')
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          workOrderType: {
            rules: [
              { required: true, message: '请选择工单类型!'},
            ]
          },
          businessSegment: {
            rules: [
              { required: true, message: '请选择项目名称!'},
            ]
          },
          remark:{
            rules: [
              { required: true, message: '请填写备注!'},
            ]
          }
        },
        url: {
          add: "/dm/dmWorkOrder/add",
          edit: "/dm/dmWorkOrder/edit",
          queryById: "/dm/dmWorkOrder/queryById"
        },ccList:[],
        dictOptionsType:{},
        workorder_phrases:[],
        formatSearchConetnt:formatSearchConetnt,
        phrases:'',
        parentList:[],
        typeChildList:[],
        hasIdNumber:true,
        noDriverId:'',
        spinTips:'',
        driverList:[]
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      //this.showFlowData();
      this.getCcList();
      this.initDictPh();
      this.getParentList();
    },
    destroyed() {
      console.log('粘贴事件触发beforeDestroy')
      // 移除事件监听，防止内存泄漏
      this.$refs.pasteContainer.removeEventListener('paste', this.handlePaste);
    },
    methods: {
      /**
       * 处理粘贴事件
       * @param {ClipboardEvent} e 粘贴事件对象
       */
      handlePaste(e) {
        console.log('粘贴事件触发')
        // 阻止默认粘贴行为（避免文本粘贴到页面）
        e.preventDefault();
        // 提取剪贴板中的文件列表
        const files = e.clipboardData?e.clipboardData.files:null;
        if (!files || files.length === 0) {
          return;
        }
        // 取第一个文件（如需多文件上传，可遍历files）
        const file = files[0];
        console.log('粘贴的文件：', file);//mp4,av
        // 图片文件预览（非图片文件可跳过）
        if (file.type.indexOf('image/') === -1 && file.type.indexOf('video/') === -1) {
          // const reader = new FileReader();
          // reader.onload = (e) => {
          //   this.filePreview = e.target.result;
          // };
          // reader.readAsDataURL(file);
          return;
        }
        this.uploadFile(file)

      },
      checkHasIdNumber(){
        getAction("/api/driverApi/checkHasIdNumber",{driverId:this.model.driverIds}).then(res=>{
          this.hasIdNumber = res.result.hasNumber;
          this.noDriverId = res.result.driverId;
        })
      },
       add (arr) {
        this.driverList = [];
        let obj = {};
        if(arr.length>1){
          let driverId = '';
          for(let k in arr){
            driverId += ','+arr[k].id;
          }
          obj.driverIds =driverId.substring(1);
          obj.driverName = arr[0].driverName+"等"+arr.length+"个司机"
          obj.dx= 1;
        }else{
          obj.driverName = arr[0].driverName;
          obj.licensePlateNumber =''
          let carList = arr[0].carList;
          console.log(carList)
          if(carList){
            for(let d in carList){
              obj.licensePlateNumber +=","+carList[d].licensePlateNumber;
            }
            obj.licensePlateNumber = obj.licensePlateNumber.substring(1);
          }
          obj.driverIds = arr[0].id+"";
          this.searchDriver(obj.driverIds);
        }
        console.log(obj)

         obj.backType =0;
         this.initDictConfig();
        this.edit(obj);
      },
      searchDriver (driverId) {
        getAction("/api/workorderApi/selectWorkorderDriverList",{createType:1,driverId:driverId}).then(res=>{
          if(res.success){
            this.driverList = res.result;
          }

        }).catch(()=>{})
      },
      customRender(text){
        //字典值替换通用方法
        return filterDictText(this.dictOptionsType, text);
      },
      async initDictConfig(){
        //初始化字典
        await  initDictOptions('work_order_type').then((res) => {
          if (res.success) {
            this.dictOptionsType = res.result;
          }
        });
      },  initDictPh(){
        //初始化字典
        initDictOptions('workorder_phrases').then((res) => {
          if (res.success) {
            this.workorder_phrases = res.result;
          }
        });
      },
      edit (record) {
        this.typeChildList = []
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(this.model.workOrderType){
          this.model.phrases = this.customRender(this.model.workOrderType);
          this.getChildList();
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'driverIds','backType','workOrderTypeChild','transfer','phrases','imageFile','driverName','workOrderType','businessSegment','workOrderStatus','remark','createBy','createTime','updateBy','updateTime','videoUrl'))
        })
        this.checkHasIdNumber();
        this.$nextTick(() => {
          console.log('粘贴事件触发created',this.$refs.pasteContainer)
          this.$refs.pasteContainer.addEventListener('paste', this.handlePaste);
        });
      },
      //渲染流程表单数据
       showFlowData(id){
         this.getCcList();
        //if(this.formBpm === true){
          let params = {id:id};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        //}
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            if(this.hasIdNumber){
              this.submitSure(values);
            }else{
              Modal.confirm({
                title: '提示',
                content: '未完善身份证号的信息可能会与其他信息冲突，建议先完善再操作',
                okText: '去完善',
                cancelText: '忽略',
                centered: true,
                onOk: () => {
                  if(this.noDriverId){
                    this.$refs.driverForm.showInfo(null, this.noDriverId,{s:'基本信息',leftTab:1,b:'返回挂靠平台详情'})
                  }else{
                    this.$emit('close');
                  }

                },
                onCancel:() =>{
                  this.submitSure(values)
                }
              });
            }
          }

        })
      },submitSure(values){
        const that = this;
        that.confirmLoading = true;
        let httpurl = '';
        let method = '';
        if(!this.model.id){
          httpurl+=this.url.add;
          method = 'post';
        }else{
          httpurl+=this.url.edit;
          method = 'put';
        }
        let formData = Object.assign(this.model, values);
        if(formData.backType==1){
          if(!formData.day && !formData.hour && !formData.minutes){
            that.$message.error("请输入倒计时");
            return
          }
          formData.countdown = (formData.day?formData.day:0)+"-"+(formData.hour?formData.hour:0)+"-"+(formData.minutes?formData.minutes:0);
        }else if(formData.backType==2){
          if(!formData.backTime){
            that.$message.error("请选择固定时间");
            return
          }
        }
        let ArrList = [];

        if(formData.imageFile){
          let imageFileArr = formData.imageFile.split(",");
          for(let a in imageFileArr){
            ArrList.push({
              fileUrl:imageFileArr[a],
              coverImg:"",
              duration:0,
              fileType:1
            })
          }
        }
        if(formData.videoUrl){
          let videoUrlArr = formData.videoUrl.split(",");
          for(let a in videoUrlArr){
            ArrList.push({
              fileUrl:videoUrlArr[a],
              coverImg:videoUrlArr[a].substring(0,videoUrlArr[a].lastIndexOf("."))+".jpg",
              duration:0,
              fileType:2
            })
          }
        }
        if(ArrList.length>0){
          formData.videoUrl = JSON.stringify(ArrList);
        }

        httpAction(httpurl,formData,method).then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            if(res.result){
              that.$emit('ok',{id:res.result});
            }else{
              this.$confirm({
                title: '提示',
                okText: '是',
                cancelText: '否',
                content: '创建成功，是否前往我创建的列表查看？',
                onOk: () => {
                  that.$emit('ok');
                  this.$router.push({ path: "/jz/workorder/2" });
                },
                onCancel: () => {

                }
              })
            }

          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'transfer','workOrderTypeChild','driverIds','phrases','imageFile','workOrderType','businessSegment','workOrderStatus','remark','createBy','createTime','updateBy','updateTime'))
      },
      getCcList(){
        var that =this;
        that.ccList = [];
        getAction("/sys/user/queryAllList",{"permissionId":"1543471348594860033"}).then((res)=>{
          if(res.success){
            let ccList = res.result;
            if(ccList){
              ccList.sort(by_str("sortNum")).reverse();
              for(var k in ccList){
                that.ccList.push({
                  text:ccList[k].realname,
                  value:ccList[k].username
                });
              }

            }
          }
        });
      },navcatTo(path){
        this.$router.push({
          path:path
        })
        this.$emit('ok');
      },changeRemark(val){
        let txt = val.target._value;
        if(txt){
          if(txt.charAt(0)=='['){
            this.phrases=''
          }else{
            this.phrases = txt;
          }
        }else{
          this.phrases=''
        }
      },choosePhrases(ph){
        this.model.remark = ph;
        this.phrases = ''
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'remark'))
        })
      },
      getParentList(){
        getAction("/dm/dmWorkOrderType/listAll",{}).then(res=>{
          if(res.success){
            let list = res.result;
            if (list) {
              for (var k in list) {
                this.parentList.push({
                  text: list[k].name,
                  value: list[k].id
                });
              }

            }
          }
        });
      },
      async getChildList(){
        this.typeChildList = [];
        await  getAction("/dm/dmWorkTrackType/listByTypeId",{typeId:this.model.workOrderType}).then(res=>{
          if(res.success){
            let list = res.result;
            if (list) {
              for (var k in list) {
                this.typeChildList.push({
                  text: list[k].name,
                  value: list[k].id
                });
              }

            }
          }
        });
      },changeWordorderType(val){
        this.model.workOrderType = val;
        this.model.workOrderTypeChild = undefined;
        this.$refs.child.clear();
        if(val){
          this.getChildList();
        }else{
          this.typeChildList = []
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'workOrderTypeChild'))
        })
      },switchType(type){
         this.model.backType = type;

      }, /**
       * 上传文件到服务器
       * @param {File} file 要上传的文件
       */
      async uploadFile(file) {
        try {
          this.confirmLoading = true;
          this.spinTips = "上传中...";
          // 封装FormData（后端需接收multipart/form-data类型）
          const formData = new FormData();
          formData.append('file', file); // 后端通过"file"获取文件
          const token = getAccessToken();
          // 发送上传请求（替换为你的后端接口）
          const response = await axios.post(window._CONFIG['domianURL']+"/sys/common/upload", formData, {
            headers: {
              "X-Access-Token":token
            },
            onUploadProgress: (progressEvent) => {
              // 可选：处理上传进度
              const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              this.spinTips=`上传进度：${percent}%`;
            }
          });
          if(file.type.indexOf("image/")!==-1){
            // 上传成功处理
            if(this.model.imageFile){
              this.model.imageFile = this.model.imageFile+","+response.data.message;
            }else{
              this.model.imageFile = response.data.message;
            }

            this.form.setFieldsValue(pick(this.model,'imageFile'))
          }else{
            if(this.model.videoUrl){
              this.model.videoUrl = this.model.videoUrl+","+response.data.message;
            }else{
              this.model.videoUrl = response.data.message;
            }
            this.form.setFieldsValue(pick(this.model,'videoUrl'))
          }


        } catch (error) {
          console.error(error);
          // 上传失败处理
          this.$message.error("文件上传失败，请重试！");
        } finally {
          this.confirmLoading = false;
          this.spinTips = "";
        }
      }
    }
  }
</script>
<style lang="less" scoped>

  /deep/ .ant-col-xs-24{
    float: inherit;
  }
  /deep/ .ant-form-item{
    margin-bottom: 0px !important;
  }

  .form-box{
    padding:24px;
  }
  .phrases-box{
    max-height: 400px;
    background:rgba(255, 255, 255, 1);
    color: rgba(56, 56, 56, 1);
    margin-top: -10px;
    padding-top: 10px;

  }
  .phrases-box div{
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    cursor: pointer;
  }


  .info-card {
    border-radius: 18px;
    padding: 8px 18px;
    max-width: 600px;
    margin: 0 auto;
    background: #E6EDF5;
    margin-bottom: 20px;
  }
  .info-item{
    padding: 3px 0;
  }

  .info-item:last-of-type {
    border-bottom: none;
  }

  .info-label {
    color: #666;
  }

  .info-value {
    color: #333;
  }

  .red-text {
    color: #f5222d;
  }

  .check-item {
    margin-top: 4px;
    text-align: right;
  }

  /deep/ .ant-input{
    background: #fff !important;
  }
  /deep/ .ant-select-selection{
    background: #fff !important;
  }


  /deep/ .ant-input-disabled{
    background: #E6EDF5 !important;
  }

</style>
